// extracted by mini-css-extract-plugin
export default {"individual":"individual_individual__QuAMZ","wrapper":"individual_wrapper__jiCuG","content":"individual_content__nFk6P","image_wrapper":"individual_image_wrapper__FbNE4"};